import React from "react";
import styles from "./Sidebar.module.css";
import { FiUsers, FiPackage, FiBox, FiHelpCircle } from "react-icons/fi";

export type SidebarTab =
  | "Inquiry"
  | "Customers"
  | "Orders"
  | "Inventory"
  | "Appointment";

interface SidebarProps {
  selected: SidebarTab;
  onSelect: (tab: SidebarTab) => void;
}

const menuItems: { tab: SidebarTab; label: string; icon: React.ReactNode }[] = [
  { tab: "Inquiry", label: "Inquiry", icon: <FiHelpCircle size={20} /> },
  { tab: "Appointment", label: "Appointment", icon: <FiPackage size={20} /> },
  // { tab: "Orders", label: "Orders", icon: <FiPackage size={20} /> },
  { tab: "Customers", label: "Customers", icon: <FiUsers size={20} /> },
  { tab: "Inventory", label: "Inventory", icon: <FiBox size={20} /> },
];

const Sidebar: React.FC<SidebarProps> = ({ selected, onSelect }) => {
  return (
    <aside className={styles.sidebar}>
      <nav>
        <ul className={styles.menuList}>
          {menuItems.map((item) => (
            <li
              key={item.tab}
              className={
                styles.menuItem +
                (selected === item.tab ? " " + styles.active : "")
              }
              onClick={() => onSelect(item.tab)}
              tabIndex={0}
              role="button"
              aria-pressed={selected === item.tab}
            >
              <span className={styles.menuIcon}>{item.icon}</span>
              <span>{item.label}</span>
            </li>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
